import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';

import { firstValueFrom } from 'rxjs';

import { TranslocoService } from '@jsverse/transloco';

import { LanguageService } from './language.service';

export const provideLanguage = (): EnvironmentProviders =>
  provideAppInitializer(() => {
    const transloco = inject(TranslocoService);
    const languageService = inject(LanguageService);

    const lang = languageService.getLanguage();
    transloco.setActiveLang(lang);
    return firstValueFrom(transloco.load(lang));
  });
